// removed by extract-text-webpack-plugin
module.exports = {"Info":"Info__Info___o1nPk","InfoClient":"Info__InfoClient___2ykcn","Inner":"Info__Inner___2S9fH","Header":"Info__Header___pOGDN","Title":"Info__Title___1a9TY","Update":"Info__Update___2xZuf","Column":"Info__Column___ijMXW","StoppedColumn":"Info__StoppedColumn___rVlVY","ColumnWrap":"Info__ColumnWrap___iq0z0","Stopped":"Info__Stopped___26qEm","Count":"Info__Count___4lEns","Name":"Info__Name___33DxX","Message":"Info__Message___riO84"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Info/Info.scss
// module id = 1300
// module chunks = 0